import type { FC } from 'react';
import type React from 'react';
import { memo } from 'react';
import { Box, Table, TableContainer } from '@mui/material';

interface IProps {
  children: React.ReactNode;
}

const MetricTableContainer: FC<IProps> = memo(({ children }) => {
  return (
    <Box sx={{ display: 'flex', position: 'relative', flex: 1, width: '100%', height: '100%' }}>
      <TableContainer>
        <Table
          sx={{
            '&': {
              height: '100%',
            },
          }}
          size="small"
        >
          {children}
        </Table>
      </TableContainer>
    </Box>
  );
});

MetricTableContainer.displayName = 'MetricTableContainer';
export default MetricTableContainer;
